import { ref, watchEffect, type Ref } from 'vue';

export type Density = 'compact' | 'default' | 'comfortable';

const STORAGE_KEY = 'shiocast.density';

function readStored(): Density {
  try {
    const value = localStorage.getItem(STORAGE_KEY);
    if (value === 'compact' || value === 'default' || value === 'comfortable') return value;
  } catch {
    // Private browsing or blocked site data. The default is always correct.
  }
  return 'default';
}

const density = ref<Density>(readStored());

/**
 * Table and card density, remembered per device. An operator on a studio wall display
 * wants different information density from one on a laptop, and neither preference
 * belongs on the server.
 */
export function useDensity(): {
  density: Ref<Density>;
  setDensity: (value: Density) => void;
} {
  return {
    density,
    setDensity(value: Density) {
      density.value = value;
    },
  };
}

export function installDensity(): void {
  watchEffect(() => {
    document.documentElement.setAttribute('data-density', density.value);
    try {
      localStorage.setItem(STORAGE_KEY, density.value);
    } catch {
      // Non-fatal: the attribute is already applied for this session.
    }
  });
}
